import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <div className="text-center mb-12">
            <Badge variant="secondary" className="mb-4">Legal</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: December 4, 2024</p>
          </div>
          <div className="prose prose-neutral dark:prose-invert max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing or using ForgeNetwork services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Description of Services</h2>
              <p className="text-muted-foreground mb-4">
                ForgeNetwork provides code analysis, documentation generation, and security scanning services. Our platform allows you to upload repositories for analysis and generate various reports including PRDs, SDDs, and security assessments.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. User Accounts</h2>
              <p className="text-muted-foreground mb-4">
                You must create an account to use our services. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>You must provide accurate and complete registration information</li>
                <li>You must be at least 18 years old to create an account</li>
                <li>You must not share your account credentials with others</li>
                <li>You must notify us immediately of any unauthorized access</li>
              </ul>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Acceptable Use</h2>
              <p className="text-muted-foreground mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Upload malicious code or attempt to compromise our systems</li>
                <li>Use our services for any illegal purpose</li>
                <li>Attempt to reverse engineer our analysis algorithms</li>
                <li>Exceed your plan's usage limits or circumvent restrictions</li>
                <li>Share analysis results that contain others' proprietary code without permission</li>
              </ul>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
              <p className="text-muted-foreground">
                You retain all rights to your uploaded code and generated analysis results. ForgeNetwork retains ownership of its platform, algorithms, and underlying technology. Our analysis does not grant us any rights to your intellectual property.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">6. Payment Terms</h2>
              <p className="text-muted-foreground">
                Paid subscriptions are billed in advance on a monthly or annual basis. Refunds are available within 14 days of initial purchase. Upgrades and downgrades take effect at the next billing cycle.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                ForgeNetwork provides services "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability is limited to the amount you paid in the past 12 months.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">8. Termination</h2>
              <p className="text-muted-foreground">
                We may terminate or suspend your account for violations of these terms. You may cancel your account at any time. Upon termination, your data will be deleted according to our data retention policy.
              </p>
            </section>
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">9. Contact</h2>
              <p className="text-muted-foreground">
                For questions about these Terms, contact us at legal@forgenetwork.pro.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
